// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading--heading--1XZ-o"};